const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.matches('.mpr-custom-label')) {
        wrapUrls(node);
      } else if (node.nodeType === 1) {
        const nested = node.querySelectorAll('.mpr-custom-label');
        nested.forEach(wrapUrls);
      }
    });
  });
});

function wrapUrls(element) {
  let text = element.innerHTML;

  const pattern = /\(\s*([^)]*?)\s*(https:\/\/[^\s)]+)\s*([^)]*?)\s*\)/g;

  text = text.replace(pattern, (match, beforeUrl, url, afterUrl) => {
    const displayText = `(${(beforeUrl + afterUrl).trim()})`; // Clean spaces around text
    return `<a href="${url}" target="_blank">${displayText}</a>`;
  });

  element.innerHTML = text;
}

observer.observe(document.body, {
  childList: true,
  subtree: true
});
